import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, {Component} from 'react';
import classNames from 'classnames';
import axios from 'axios';
import LaddaButton from 'react-ladda';
import {track} from 'js/common/analytics';

const {ShareTokenAccessLevel, createShareTokenLink} = window.sn;

export default class CreateShareLink extends Component {
    static propTypes = {
        allShareTokens: PropTypes.arrayOf(
            PropTypes.shape({
                access_level: PropTypes.string,
                campaign_id: PropTypes.number,
                id: PropTypes.number,
                token: PropTypes.string
            })
        ),
        onAlreadySharedClick: PropTypes.func.isRequired,
        onShareSucceed: PropTypes.func.isRequired,
        onShareFail: PropTypes.func,
        showAlreadyShared: PropTypes.bool.isRequired,
        email: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            accessLevel: ShareTokenAccessLevel.LIMITED,
            isEmailValid: true,
            isLoading: false,
            email: null
        };
    }

    handleContinueClick = () => {
        const {email} = this.state;

        if (!email) {
            this.setState({
                isEmailValid: false
            });
        } else {
            this.setState({
                step: this.state.step + 1
            });
        }
    };

    handleSendClick = () => {
        const {accessLevel, body, email: sharedToEmail} = this.state;
        const {
            brandName,
            campaignId,
            campaignName,
            onShareSucceed,
            onShareFail,
            email: userEmail
        } = this.props;

        this.setState(
            {
                isLoading: true
            },
            () => {
                axios
                    .post(createShareTokenLink, {email: sharedToEmail, accessLevel, body})
                    .then(resp => {
                        this.setState({
                            isLoading: false
                        });

                        track(userEmail, 'Brand - shared via email', {
                            'Campaign Funnel Id': campaignId,
                            'Campaign Funnel Name': campaignName,
                            'Brand Name': brandName,
                            'Brand Share Email': sharedToEmail
                        });

                        if (onShareSucceed) {
                            onShareSucceed(resp.data);
                        }
                    })
                    .catch(() => {
                        this.setState({isLoading: false});
                        if (onShareFail) {
                            onShareFail();
                        }
                    });
            }
        );
    };

    handleEmailChange = e => {
        this.setState({
            email: e.target.value
        });
    };

    handleAccessLevelChange = e => {
        this.setState({
            accessLevel: e.target.value
        });
    };

    handleBodyChange = e => {
        this.setState({
            body: e.target.value
        });
    };

    displayMessageBodyInput = () => {
        const {step} = this.state;

        if (step === 1) {
            return (
                <div>
                    <textarea
                        className="form-control"
                        rows="4"
                        placeholder="Enter a message to send the user"
                        name="body"
                        onChange={this.handleBodyChange}
                    />
                </div>
            );
        }

        return null;
    };

    displayCTA = () => {
        const {step, isLoading} = this.state;

        if (step === 0) {
            return (
                <button className="btn btn-info" onClick={this.handleContinueClick}>
                    SHARE CAMPAIGN
                </button>
            );
        }

        if (step === 1) {
            return (
                <LaddaButton
                    className="btn btn-info"
                    loading={isLoading}
                    onClick={this.handleSendClick}
                >
                    SEND
                </LaddaButton>
            );
        }

        return null;
    };

    displayAlreadySharedWithText() {
        const {allShareTokens} = this.props;
        const emails = R.pipe(
            R.pluck('email'),
            R.filter(R.identity)
        )(allShareTokens);

        if (R.isEmpty(emails)) {
            return null;
        }

        if (R.length(emails) <= 2) {
            return R.join(' and ', emails);
        }

        const remainingCount = R.length(emails) - 2;

        return R.pipe(
            R.slice(0, 2),
            R.join(', '),
            R.append(` and ${remainingCount} more...`)
        )(emails);
    }

    displayShowAlreadyShared = () => {
        const {onAlreadySharedClick, showAlreadyShared} = this.props;

        if (showAlreadyShared) {
            return (
                <div className="shared-with">
                    <a href="#" onClick={onAlreadySharedClick}>
                        Edit Shared With
                    </a>
                </div>
            );
        }

        return null;
    };

    render() {
        const {isEmailValid} = this.state;

        const messageBodyInput = this.displayMessageBodyInput();
        const alreadyShared = this.displayShowAlreadyShared();
        const cta = this.displayCTA();

        return (
            <div className="create-share-link">
                <div className="text-left form-group">
                    <div className={classNames('inputs-horizontal', !isEmailValid && 'error')}>
                        <input
                            className="form-control"
                            placeholder="Email"
                            onChange={this.handleEmailChange}
                        />
                    </div>

                    {messageBodyInput}

                    {alreadyShared}
                </div>

                {cta}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/share_content_modal/create_share_link.js